import ReactTooltip from "react-tooltip";
import { CLOUDINARY_INTEL_BASE_URL } from "../../../../utils/enum";
import styles from "./ProfilHeaderText.module.scss";

const ProfileHeaderText = ({ label, value, isWebsite = false, isLast = false, isCopy = false, handleCopy, tooltipLabel }) => {
  return value ? (
    <div className={styles.profileHeaderText}>
      <span>
        {label}:{" "}
        {isWebsite ? (
          [].concat(value).map((website, index) => (
            <span key={website}>
              {index > 0 ? ", " : null}
              <a href={`https://${website}`} className={styles.profileHeaderWebsiteText} target="_blank" rel="noopener noreferrer">
                {website}
              </a>
            </span>
          ))
        ) : (
          <span className={styles.profileHeaderTextValue} data-tip={tooltipLabel} data-for={tooltipLabel} data>
            {value}
          </span>
        )}
      </span>
      <ReactTooltip id={tooltipLabel} />
      {/* Copy Icon */}
      {isCopy ? <img src={`${CLOUDINARY_INTEL_BASE_URL}/v1709185641/intel/icons/hdg1qqouwpmldojxnmwh.svg`} className={styles.copyImg} onClick={() => handleCopy(value)} /> : null}
      {!isLast ? <span className={styles.seperator}>|</span> : null}
    </div>
  ) : null;
};

export default ProfileHeaderText;
